import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=0f46aea4"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=0f46aea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports